import React from "react";
import { Row, SectionHead, mono } from "./PanelAtoms";
import { mutUpdateDrawing } from "../../../engine/layerMutations";

// ── North Compass ──────────────────────────────────────────────────────────────
export function NorthCompass({ rotation, onChange }) {
  const cx=36, cy=36, r=28;
  const ang = (rotation-90)*Math.PI/180;
  const tipX=cx+r*Math.cos(ang), tipY=cy+r*Math.sin(ang);
  const tailX=cx-r*0.5*Math.cos(ang), tailY=cy-r*0.5*Math.sin(ang);
  const lx=cx+r*0.35*Math.cos(ang+Math.PI/2), ly=cy+r*0.35*Math.sin(ang+Math.PI/2);
  const rx2=cx+r*0.35*Math.cos(ang-Math.PI/2), ry2=cy+r*0.35*Math.sin(ang-Math.PI/2);
  const handleClick = e => {
    const rect=e.currentTarget.getBoundingClientRect();
    const dx=e.clientX-rect.left-cx, dy=e.clientY-rect.top-cy;
    onChange((Math.round(Math.atan2(dy,dx)*180/Math.PI+90+360))%360);
  };
  return (
    <div style={{ padding:"8px 12px 4px", display:"flex", alignItems:"center", gap:12 }}>
      <svg width={72} height={72} style={{ cursor:"pointer", flexShrink:0 }} onClick={handleClick}>
        <circle cx={cx} cy={cy} r={r} fill="#06111e" stroke="#0d1520" strokeWidth={1.5}/>
        {[["N",cx,cy-r+8],["S",cx,cy+r-4],["E",cx+r-5,cy+4],["W",cx-r+5,cy+4]].map(([l,x,y])=>(
          <text key={l} x={x} y={y} textAnchor="middle" fontSize={8}
            fontFamily={mono.fontFamily} fill="#2a3a4a" fontWeight={700}>{l}</text>
        ))}
        {[0,45,90,135,180,225,270,315].map(a=>{
          const rad=(a-90)*Math.PI/180, r1=a%90===0?r-6:r-4;
          return <line key={a} x1={cx+r1*Math.cos(rad)} y1={cy+r1*Math.sin(rad)}
            x2={cx+(r-2)*Math.cos(rad)} y2={cy+(r-2)*Math.sin(rad)}
            stroke="#131924" strokeWidth={a%90===0?1.5:1}/>;
        })}
        <polygon points={`${tipX},${tipY} ${lx},${ly} ${tailX},${tailY}`} fill="#3b82f6"/>
        <polygon points={`${tipX},${tipY} ${rx2},${ry2} ${tailX},${tailY}`}
          fill="#06111e" stroke="#3b82f6" strokeWidth={1}/>
        <circle cx={cx} cy={cy} r={3} fill="#3b82f6"/>
      </svg>
      <div>
        <div style={{ fontSize:8, color:"#2a3a4a", letterSpacing:1, marginBottom:4, ...mono }}>NORTH °</div>
        <input type="number" value={rotation} min={0} max={359}
          onChange={e => onChange((Number(e.target.value)+360)%360)}
          style={{ width:54, background:"#06111e", border:"1px solid #0d1520",
            color:"#60a5fa", borderRadius:3, padding:"3px 6px",
            fontSize:11, ...mono, outline:"none", textAlign:"center" }}/>
        <div style={{ fontSize:8, color:"#1e2a36", marginTop:2, ...mono }}>Click compass</div>
      </div>
    </div>
  );
}

// ── Origin panel ───────────────────────────────────────────────────────────────
export function OriginPanel({ st, onResetOrigin }) {
  const nodes = Object.values(st.nodes||{});
  if (!nodes.length) return <div style={{ padding:"8px 12px", fontSize:10, color:"#1e2a36" }}>No geometry</div>;
  const xs=nodes.map(n=>n.x), ys=nodes.map(n=>n.y);
  const minX=Math.min(...xs), maxX=Math.max(...xs), minY=Math.min(...ys), maxY=Math.max(...ys);
  return (
    <div>
      <Row label="Origin X">{minX} mm</Row>
      <Row label="Origin Y">{minY} mm</Row>
      <Row label="Span W">{((maxX-minX)/1000).toFixed(2)} m</Row>
      <Row label="Span H">{((maxY-minY)/1000).toFixed(2)} m</Row>
      <div style={{ padding:"4px 12px" }}>
        <button onClick={onResetOrigin}
          style={{ width:"100%", padding:"5px", background:"#06111e",
            border:"1px solid #0d1520", color:"#3b82f6",
            borderRadius:3, cursor:"pointer", fontSize:9, ...mono }}>
          ↺ Reset origin to (0,0)
        </button>
      </div>
    </div>
  );
}
